import Profileimg from '../../images/profileimg.jpg';
import './content.css'

export default function About() {
  const handleDownload = () => {
    fetch('jayesh_resume.pdf')
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'jayesh_resume.pdf';
        link.click();
      });
  };
  
  return (
    <div className='aboutcntr'>
        <div className='profileimg'>
            <img src={Profileimg} alt='profileimg' />
        </div>
        <div className='profiledetails'>
            <h1>Jayesh B. Gawade</h1>
            <p><strong>Department:</strong>Computer Engineering</p>
            <p><strong>Age:</strong> 26</p>
            <p className='mydetails'>Hi, My Name is Jayesh B. Gawade and I am a Computer Engineer, 
            I Was Completed My Computer Engineering in 2020 with strong skills in web development, including 
            HTML, CSS, JavaScript, React, PHP, and data structures and algorithms.</p>
            <p className='mydetails'>Proficient in designing and implementing user-friendly and responsive websites 
            and web applications.</p>
            <p className='mydetails'>Committed to using technology to make a positive impact 
            and eager to bring my skills and passion to a dynamic and innovative company.
            </p>
            <button onClick={handleDownload}>Download My Resume</button>
        </div>
    </div>
  )
}
